import ApiService from "../api.services";

const CustomerService = {
  list: async function (records, page, customerType, name) {
    try {
      const response = await ApiService.get(
        `/api/customers?page=${page}&records=${records}&type=${customerType}&name=${name}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  select: async function (records, page, customerType, name, pdv) {
    try {
      const response = await ApiService.get(
        `/api/customers?page=${page}&records=${records}&type=${customerType}&name=${name}&list=true${pdv ? "&pdv=true" : ""}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  limit: async function (id) {
    try {
      const response = await ApiService.get(`/api/customers/limit/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  history: async function (id, month, offset, limit) {
    try {
      const response = await ApiService.get(
        `/api/customers/limit/history/${id}?month=${month}&offset=${offset}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  me: async function () {
    try {
      const response = await ApiService.get(`/api/customers/data/me`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  address: async function (customer) {
    try {
      const response = await ApiService.get(
        `/api/customers/address/${customer}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  findByFederalId: async function (federalid) {
    try {
      const response = await ApiService.get(
        `/api/customers/federal_id/${encodeURIComponent(federalid)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (form, services, cardpost, address) {
    const data = form;
    data.services = services;
    data.cardpost = cardpost;
    data.addressList = address;
    try {
      const response = await ApiService.post("/api/customers", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, form, services, cardpost, address) {
    const data = {
      customer: form,
    };
    data.customer.services = services;
    data.customer.cardpost = cardpost;
    data.customer.addressList = address;
    console.log("data", data);
    try {
      const response = await ApiService.put(`/api/customers/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  branch: async function (id, data) {
    try {
      const response = await ApiService.put(
        `/api/customers/branch/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  cardpost: async function (id) {
    try {
      const response = await ApiService.get(`/api/customers/cardpost/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  save: async function (data) {
    try {
      const response = await ApiService.put(`/api/customers/data/me`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  customerCardpost: async function (id, code) {
    try {
      const response = await ApiService.get(
        `/api/customers/cardpost/${id}/${code}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  license: async function (id) {
    try {
      const response = await ApiService.get(`/api/customers/license/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  transfer: async function (destiny, list) {
    try {
      const response = await ApiService.post(
        `/api/customers/transfer/${destiny}`,
        list
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  branchName: async function (id, name) {
    try {
      const response = await ApiService.get(
        `/api/customers/branch/${id}?name=${encodeURIComponent(name)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getBranchsByCustomer: async function (customer_id) {
    try {
      const response = await ApiService.get(
        `/api/customers/find/branchs/${customer_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CustomerService;

export { CustomerService };
